import * as Api from '@Api/index';

import type { ProductData } from '@Types/Product';

export interface GetSimilarProductsParams {
  productId: number;
  limit?: number;
}

interface SimilarProductsResponse {
  ok: boolean;
  data: {
    products: Record<string, { similar: ProductData[] }>;
  };
}

let timer = null;
const productIds: number[] = [];
const resolvers: ((response: SimilarProductsResponse) => void)[] = [];

/**
 * Функция, получающая массив похожих товаров для товара с заданным `productId`.
 * Запросы к API группируются и выполняются с задержкой в 300 мс.
 * @param params.productId - Идентификатор товара, для которого запрашиваем массив похожих товаров.
 * @param params.limit - Максимальное количество похожих товаров в массиве (по умолчанию 5).
 * @returns Промис с несколькими массивами похожих товаров.
 */
async function getSimilarProducts({ productId, limit = 5 }: GetSimilarProductsParams) {
  return new Promise<SimilarProductsResponse>((resolve) => {
    productIds.push(productId);
    resolvers.push(resolve);

    if (timer) return;

    timer = setTimeout(async () => {
      const currentProductIds = productIds.slice(0);
      const currentResolvers = resolvers.slice(0);

      timer = null;
      productIds.length = 0;
      resolvers.length = 0;

      const url = `/backend/v2/products/${currentProductIds.join(',')}/similar?limit=${limit}`;
      const res = await Api.queryProxi<SimilarProductsResponse>(url);

      currentResolvers.forEach((resolver) => {
        resolver(res);
      });
    }, 300);
  });
}

export default getSimilarProducts;
